module.exports = __webpack_public_path__ + "img/bg.1151166b.jpg";